module.exports = __webpack_public_path__ + "img/xaas-instagram.74a3f5f.png";